import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import AdvancePaymentList from "./AdvancePaymentList";
import { CallApiPost } from "../Helper/serviceApi";
import ReactDatePicker from "react-datepicker";
import { DATE_FORMAT_CLIENT, DATE_FORMAT_SERVER } from "../Helper/Constants";
import moment from "moment";
import GetSvgIcon from "../../images/svglist";
import AdvancePaymentDetails from "./AdvancePaymentDetails";
const { Buffer } = require("buffer");

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};
const initConfirmAlert = {
  size: "md",
  show: false,
  title: "",
  description: "",
};
const initialModalConfig = {
  show: false,
  title: "",
  size: "lg",
  data: [],
};
const AdvancePaymentMain = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(
    Object.assign({}, initAlertConfig)
  );
  const [confirmAlertConfig, setConfirmAlertConfig] = useState(
    Object.assign({}, initConfirmAlert)
  );
  const hideConfirmAlert = () => {
    setConfirmAlertConfig(Object.assign({}, initConfirmAlert));
  };
  const [openModalConfig, setOpenModalConfig] = useState(
    Object.assign({}, initialModalConfig)
  );
  const [advListData, SetAdvListData] = useState([]);
  const [toDate, setToDate] = useState(
    moment(new Date()).add(7, "days").format(DATE_FORMAT_SERVER)
  );
  const [fromDate, setFromDate] = useState(
    moment(new Date()).subtract(7, "days").format(DATE_FORMAT_SERVER)
  );

  useEffect(() => {
    fetchAdvanceDataList();
  }, []);
  const hideAlert = () => {
    setAlertConfig({
      isSuccess: false,
      size: "md",
      show: false,
      title: "",
      description: "",
    });
  };
  const openModal = (argData, argTitle) => {
    setOpenModalConfig({
      show: true,
      title: argTitle,
      size: "lg",
      data: argData,
    });
  };
  const openCustAdv = (data) => {
    const encodedData = Buffer.from(
      JSON.stringify({
        custId: data?.customer_id,
        fromDate: fromDate,
        toDate: toDate,
      })
    ).toString("base64");
    const url = `/advDetails/${encodedData}`;
    window.open(url, "_blank");
  };

  const fetchAdvanceDataList = async () => {
    let payload = {
      dateFrom: moment(fromDate).format(DATE_FORMAT_SERVER),
      dateTo: moment(toDate).format(DATE_FORMAT_SERVER),
    };
    setShowSpinner(true);
    const data = await CallApiPost("getAdvPayDtlsByIdSummary", payload);
    if (data.respCode === 200) {
      SetAdvListData(data.respData);
    }
    setShowSpinner(false);
  };

  return (
    <>
      <Layout
        spinnershow={showSpinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
        confirmAlertConfig={confirmAlertConfig}
        hideConfirmAlert={hideConfirmAlert}
      >
        <div className="clearfix border-bottom pb-2 mb-2">
          <div className="float-start">
            <div className="section-title mt-1">Advance Payment</div>
          </div>
        </div>
        <div className="d-flex align-item-center justify-content-between py-3 m-1">
          <div className="col-auto">
            <div className="border rounded p-2 me-3 wt-tbl float-start">
              <div className="d-flex align-item-center">
                <div className="col-auto align-self-center d-flex">
                  <label
                    htmlFor=""
                    className="form-label theme-label align-self-center me-2"
                    title="This field is mandatory"
                  >
                    From Date:
                  </label>
                  <ReactDatePicker
                    placeholderText="Select Trip Date"
                    className="form-control"
                    dateFormat={DATE_FORMAT_CLIENT}
                    selected={!!fromDate ? new Date(fromDate) : fromDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setFromDate(d)}
                    onSelect={(d) => setFromDate(d)}
                    maxDate={new Date(toDate)}
                  />
                  {/* <ReactDatePicker
                      placeholderText="Select Trip Date"
                      className="form-control"
                      dateFormat={DATE_FORMAT_CLIENT}
                      selected={!!tripDate ? new Date(tripDate) : tripDate}
                      onFocus={(e) => e.target.blur()}
                      onChange={(d) => setTripDate(d)}
                      onSelect={(d) => setTripDate(d)}
                    /> */}
                </div>
                <div className="col-auto align-self-center d-flex">
                  <label
                    htmlFor=""
                    className="form-label theme-label ms-3 align-self-center"
                    title="This field is mandatory"
                  >
                    To Date:
                  </label>
                  <ReactDatePicker
                    placeholderText="Select Trip Date"
                    className="form-control "
                    dateFormat={DATE_FORMAT_CLIENT}
                    selected={!!toDate ? new Date(toDate) : toDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setToDate(d)}
                    onSelect={(d) => setToDate(d)}
                    minDate={new Date(fromDate)}
                  />
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn btn-outline-secondary theme-violet text-nowrap float-end mt-2"
              onClick={() => fetchAdvanceDataList()}
              // disabled={!(!!tripDate && !!origin)}
              disabled={!(!!fromDate && !!toDate)}
            >
              {GetSvgIcon("Search")}
            </button>
          </div>
        </div>
        <AdvancePaymentList tableData={advListData} openCustAdv={openCustAdv} />
      </Layout>
    </>
  );
};

export default AdvancePaymentMain;
